import React, { useState } from "react";
import alertify from 'alertifyjs';
import { Select } from 'antd';
import {
  UserOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { Modal, Button } from 'antd';



export function newFormatDate(fecha) {
    var diaActual = new Date(fecha);
  
    var day = diaActual.getDate() < 10 ? "0" + diaActual.getDate() : diaActual.getDate();
    var month = (diaActual.getMonth() + 1) < 10 ? "0" + (diaActual.getMonth() + 1) : (diaActual.getMonth() + 1);
    var year = diaActual.getFullYear();
  
    var hora = diaActual.getHours() < 10 ? "0" + diaActual.getHours() : diaActual.getHours();
    var minutos = diaActual.getMinutes() < 10 ? "0" + diaActual.getMinutes() : diaActual.getMinutes();
  
    return fecha = day + '/' + month + '/' + year + ' ' + hora + ':' + minutos;
  }




  export function checkMatricula(text) {
    const that = this;
    let p = "[A-Z]{1,2}\\d{4}[A-Z]{1,3}|^\\d{4}[A-Z]{3}";
    let regExp = new RegExp(p);
    //match
    if (!regExp.test(text.toUpperCase())) {
        this.setState({
            _enabled: false,
            _colorInpur: "red",
            msgerror: "Matrícula incorrecta",
        });

    } else {
        //5497BNL
        //ok
       // store.dispatch(searchMatricula(text));
    }

}


export function encriptarBastidor(text) {
    let nuevoBastidor =  "";

    for(var i=0; i < text.length ; i++){
        nuevoBastidor += "*";
    } 
   
    return nuevoBastidor;
}



export function MSGAltaUsuario(texto) {
  Modal.info({
    content: (
      <div>
        <img src="./academyGris.png" alt="logo academy" style={{ width: '400px' }} ></img>

        <h4 className="m-4">Se ha registrado correctamente en el curso.</h4>

        <img src="./patrocinadores.jpg" style={{ width: '730px' }} ></img>
      </div>
    ),
    width: (800),
    footer: (null),
    okText: "Entendido.",
    onOk() { },
  });
}



